import { toast } from 'react-toastify'
import Swal from 'sweetalert2'
import DangerIcon from '../assets/images/notifications/error-icon.svg'
import SuccessIcon from '../assets/images/notifications/success-icon.svg'
import CustomCloseButton from '../layouts/components/CustomCloseButton.jsx'
import 'react-toastify/dist/ReactToastify.css'

export const showNotification = (
    message,
    type,
    timer = 5000,
    button = null,
    callback = null,
    closeButton = true,
    timerRun = false,
) => {
    const theme = document.documentElement.getAttribute('data-theme') || localStorage.getItem('theme') || 'light'

    const icon = () => {
        if (type === 'info') {
            return (
                <svg
                    width="40"
                    height="40"
                    viewBox="0 0 24 24"
                    fill="#D97706"
                    xmlns="http://www.w3.org/2000/svg"
                    className="toast-icon"
                >
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm.75 15h-1.5v-6h1.5v6zm0-8h-1.5V7h1.5v2z" />
                </svg>
            )
        } else if (type === 'success') {
            return <img src={SuccessIcon} alt="success icon" className="toast-icon" />
        } else if (type === 'error') {
            return <img src={DangerIcon} alt="error icon" className="toast-icon" />
        }
        return null
    }

    const MessageWithButton = () => (
        <div className="toast-body">
            {icon()}
            <div className="toast-text">
                {message}
                {button && (
                    <div className="toast-button-wrapper">
                        <button
                            className="toast-action-button"
                            onClick={() => {
                                toast.dismiss()
                                if (callback) callback()
                            }}
                        >
                            {button}
                        </button>
                    </div>
                )}
            </div>
        </div>
    )

    const toastId = `${type}-${message}`

    if (toast.isActive(toastId)) return

    toast[type](<MessageWithButton />, {
        toastId,
        position: 'top-center',
        autoClose: type === 'success' || timerRun ? timer : false,
        hideProgressBar: false,
        closeOnClick: closeButton,
        pauseOnHover: true,
        draggable: closeButton,
        theme: 'colored',
        closeButton: <CustomCloseButton />,
        icon: type === 'error' || type === 'success' ? false : undefined,
        className: `toast-${type} ${theme}`,
        bodyClassName: `toast-body ${theme}`,
    })
}

export const askConfirmation = (text, confirmButtonText, callback, args = null) => {
    Swal.fire({
        title: 'Are you sure?',
        html: `
            <div class="swal-custom-icon-wrapper">
                <img src="${DangerIcon}" alt="Warning icon" class="swal-custom-icon" />
                <p>${text}</p>
            </div>
        `,
        showCancelButton: true,
        backdrop: `rgba(60,60,60,0.7)`,
        confirmButtonText: confirmButtonText,
        customClass: {
            htmlContainer: 'swal-html-with-icon',
        },
    }).then((result) => {
        if (result.isConfirmed) {
            callback(args)
        }
    })
}
